import { createFileRoute } from '@tanstack/react-router'
import { ErrorState } from '@/components/empty-state'
import { PageHeader } from '@/components/page-header'
import { Skeleton } from '@/components/ui/skeleton'
import { FelSettingsForm } from '@/features/admin/billing/fel-settings-form'
import { useSettings } from '@/features/admin/institution/api'
import { requirePermission } from '@/lib/route-guards'

export const Route = createFileRoute('/_app/admin/billing')({
  beforeLoad: requirePermission('settings:manage'),
  component: FelSettingsPage,
})

/** Administración › Facturación electrónica (FEL). */
function FelSettingsPage() {
  const { data, isLoading, error, refetch } = useSettings()
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Administración"
        title="Facturación electrónica"
        description="Factura electrónica en línea (FEL) de la SAT por los intereses, la mora, los gastos y el IVA cobrados en cada pago."
      />
      {isLoading ? (
        <Skeleton className="h-96 rounded-xl" />
      ) : error || !data ? (
        <div className="rounded-xl border border-border bg-card">
          <ErrorState error={error} onRetry={() => void refetch()} />
        </div>
      ) : (
        <FelSettingsForm settings={data.settings} />
      )}
    </div>
  )
}
